// extracted by mini-css-extract-plugin
export default {"top__panel":"TopPanel_top__panel__KumnV"};